import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import cui from 'components/cui/cui';
const { TextArea: TextAreaAnt } = Input;

const TextArea = ({ title, name, handleOnChange, onEnter, extensionClass, readOnly,
  errorMsg, customClass, customTitle, autoSize, minRows, maxRows, rows, ...rest }) => {
  const onChange = (e) => {
    const { value } = e.target;
    handleOnChange(value, name);
  }

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      onEnter();
    }
  }

  return (
    <>
      <div className={`text-area ${customClass || ''} ${readOnly ? 'readOnly' : ''}`}>
        {title && <span className={`text-area__title ${customTitle || ''}`}>{title}</span>}
        <TextAreaAnt
          {...rest}
          readOnly={readOnly}
          rows={rows}
          autoSize={autoSize ? { minRows, maxRows } : false}
          className={`${extensionClass} ${errorMsg && 'border-red'}`}
          onChange={onChange}
          onKeyDown={handleOnKeyDown}
        />
        {!cui.isUndefinedOrNull(errorMsg) &&
          <div className="err-msg">{errorMsg}</div>
        }
      </div>
    </>
  );
}

TextArea.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  row: PropTypes.number,
  autoSize: PropTypes.bool,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  handleOnChange: PropTypes.func,
  onEnter: PropTypes.func
};

TextArea.defaultProps = {
  value: '',
  rows: 3,
  minRows: 3,
  maxRows: 5,
  autoSize: true,
  autoFocus: false,
  handleOnChange: () => { },
  onEnter: () => { }
};

export default React.memo(TextArea);
